/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientUserRolesViewModel } from '../../models/client-user-roles-view-model';

export interface GetClientUserRoles$Params {
  clientID: number;
}

export function GetClientUserRoles(http: HttpClient, rootUrl: string, params: GetClientUserRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientUserRolesViewModel>> {
  const rb = new RequestBuilder(rootUrl, GetClientUserRoles.PATH, 'get');
  if (params) {
    rb.path('clientID', params.clientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientUserRolesViewModel>;
    })
  );
}

GetClientUserRoles.PATH = '/api/Clients/GetClientUserRoles/{clientID}';
